// extracted by mini-css-extract-plugin
export default {"singleRewardWrapper":"C7xTiU6jcU5pkzrUCNED","mainRewardLabel":"GOXpyYUYCKiDgjJKrCNF","last":"LT_x2SYc6AyE9PJUdyaF"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"singleRewardWrapper\":\"C7xTiU6jcU5pkzrUCNED\",\"mainRewardLabel\":\"GOXpyYUYCKiDgjJKrCNF\",\"last\":\"LT_x2SYc6AyE9PJUdyaF\"}";
        // 1755964994458
        var cssReload = require("../../../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  